import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import "./Layout.scss";
import { LinkRoute } from "../ui";

function ShowcaseLayout() {
  const location = useLocation();
  return (
    <div className="layout">
      <aside className="sidebar">
        <nav>
          <ul>
            <li>
              <LinkRoute
                to="/"
                variant="secondary"
                size="md"
                className={location.pathname === "/" ? "active" : ""}
              >
                Home
              </LinkRoute>
            </li>
            <li>
              <LinkRoute
                to="/showcase/buttons"
                variant="primary"
                size="md"
                className={
                  location.pathname === "/showcase/buttons" ? "active" : ""
                }
              >
                Buttons
              </LinkRoute>
            </li>
            <li>
              <LinkRoute
                to="/showcase/textbox"
                variant="primary"
                size="md"
                className={
                  location.pathname === "/showcase/textbox" ? "active" : ""
                }
              >
                Textbox
              </LinkRoute>
            </li>
            <li>
              <LinkRoute
                to="/showcase/ShowcaseLabelNSupportingText"
                variant="primary"
                size="md"
                className={
                  location.pathname === "/showcase/ShowcaseLabelNSupportingText" ? "active" : ""
                }
              >
                Label & supporting test
              </LinkRoute>
            </li>
            <li>
              <LinkRoute
                to="/showcase/dropdown"
                variant="primary"
                size="md"
                className={
                  location.pathname === "/showcase/dropdown" ? "active" : ""
                }
              >
                Dropdown
              </LinkRoute>
            </li>
            <li>
              <LinkRoute
                to="/showcase/accordion"
                variant="primary"
                size="md"
                className={
                  location.pathname === "/showcase/accordion" ? "active" : ""
                }
              >
                Accordion
              </LinkRoute>
            </li>
            <li>
              <LinkRoute
                to="/showcase/tabsBreadcrumb"
                variant="primary"
                size="md"
                className={
                  location.pathname === "/showcase/tabsBreadcrumb"
                    ? "active"
                    : ""
                }
              >
                Tabs/Breadcrumb
              </LinkRoute>
            </li>
            <li>
              <LinkRoute
                to="/showcase/pagination"
                variant="primary"
                size="md"
                className={
                  location.pathname === "/showcase/pagination" ? "active" : ""
                }
              >
                Pagination
              </LinkRoute>
            </li>
            <li>
              <LinkRoute
                to="/showcase/radioButtonCheckbox"
                variant="primary"
                size="md"
                className={
                  location.pathname === "/showcase/radioButtonCheckbox" ? "active" : ""
                }
              >
                Radio Checkbox
              </LinkRoute>
            </li>
            <li>
              <LinkRoute
                to="/showcase/ShowcaseIcons"
                variant="primary"
                size="md"
                className={
                  location.pathname === "/showcase/ShowcaseIcons" ? "active" : ""
                }
              >
                Icons
              </LinkRoute>
            </li>
          </ul>
        </nav>
      </aside>
      <main className="main-content">
        <Outlet />
      </main>
    </div>
  );
}

export default ShowcaseLayout;
